(function () {
  "use strict";

  function initHero(root) {
    const stage = root.querySelector(".hero-stage");
    const playBtn = root.querySelector(".hero-play");
    const videoMedia = root.querySelector("video-media.hero-video");

    if (!stage || !playBtn || !videoMedia) {
      return;
    }

    playBtn.addEventListener("click", () => {
      stage.classList.add("is-playing");
      if (typeof videoMedia.play === "function") {
        videoMedia.play();
      }
    });
  }

  function init() {
    document.querySelectorAll("[data-mt5bw-hero]").forEach(initHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
